let baseLink;
let environment = process.env["NODE_ENV"];

if(environment === 'development'){
  // Used by the CI for now do not commit changes
  baseLink = "https://test.legalplace.eu";
}else{
  baseLink = "";
}
// }


export default baseLink;


// WEBPACK FOOTER //
// ./src/baseLink.js